var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AccountPropertySection',_vm._b({attrs:{"placeholder":_vm.t('settings', 'Your phone number'),"autocomplete":"tel","type":"tel","on-validate":_vm.onValidate}},'AccountPropertySection',_vm.phone,false,true))
}
var staticRenderFns = []

export { render, staticRenderFns }